export default __webpack_public_path__ + "static/media/arpa1.a0022d14.mp3";